import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTranexamicAcidGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M36.99 25.5h2.26c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.58L33.33 8.6a.767.767 0 0 0-.74-.6.75.75 0 0 0-.73.59L28.51 24h-6.55c-2.06 0-4.21.71-5.59 2.46V9.5h5.61c.41 0 .75-.34.75-.75a.74.74 0 0 0-.74-.75H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h6.13v29.75c0 .41.34.75.75.75s.75-.34.75-.75v-7.81c0-5.37 3.91-5.94 5.59-5.94h6.22l-2.95 13.59c-.09.41.17.8.57.89.41.08.8-.17.89-.57l3.02-13.91h5.73l3.02 13.91c.08.35.39.59.73.59a.75.75 0 0 0 .73-.91L36.99 25.5ZM30.05 24l2.54-11.71L35.13 24h-5.08Z",
    fill: "currentColor"
  }));
}

export { SvgTranexamicAcidGlyphSecondary as default };
